export {
  mapFhirToRelatedPersonModel,
  mapFhirToRelatedPersonModelWithId,
  mapModelToFhirRelatedPerson,
  mapModelWithIdToFhirRelatedPerson,
} from './mapping';
export type {
  CreateRelatedPerson,
  PartialRelatedPerson,
  RelatedPerson,
  RelatedPersonGetAllResponse,
  RelatedPersonGetResponse,
  RelatedPersonSearchParams,
  RelatedPersonUpdate,
} from './schema';
export {
  CreateRelatedPersonSchema,
  PartialRelatedPersonSchema,
  RelatedPersonGetAllResponseSchema,
  RelatedPersonGetResponseSchema,
  RelatedPersonSchema,
  RelatedPersonSearchParamsSchema,
  RelatedPersonUpdateSchema,
  RelatedPersonWithIdSchema,
} from './schema';
